{
  "actionModals": {
    "assign": {
      "aria": "Assign vendor",
      "overrideScore": "Override winner score (admin force-pick)",
      "reasonLabel": "Reason (≥ 10 chars)*",
      "submit": "Assign vendor",
      "submitting": "Assigning…",
      "subtitle": "Assign or change the vendor for this order. Reason must be at least 10 characters — it will be written to the audit log.",
      "title": "Assign / Reassign vendor",
      "toastError": "Failed to assign vendor",
      "toastSuccess": "Vendor assigned",
      "vendorLabel": "Vendor*",
      "vendorPlaceholder": "Pick vendor…"
    },
    "cancel": {
      "aria": "Cancel order",
      "cancelAllItems": "cancel all items",
      "compAmountLabel": "Compensation (USD)*",
      "compEnable": "Issue compensation to vendor",
      "compLegend": "Vendor compensation",
      "compReasonLabel": "Compensation reason*",
      "irreversibleAck": "I confirm I understand this action is permanent.",
      "irreversibleBody": "Once an order moves to the cancelled state, the system has no restore path — if it needs reprocessing, the merchant must create a new order (outside this cancel + refund flow). Make sure you picked the right mode (soft / force), the right items (or the whole order), and that the refund policy matches the agreement with the merchant.",
      "irreversibleTitle": "This action cannot be undone.",
      "itemMeta": "qty {{qty}} · {{status}}",
      "itemsLegend": "Items to cancel (leave empty = all)",
      "modeForce": "Force cancel",
      "modeSoft": "Soft cancel (cancellable items only)",
      "notifyMerchant": "Notify merchant (email)",
      "reasonCodeLabel": "Reason code*",
      "reasonTextLabel": "Reason text (≥ 10 chars)*",
      "refundAmountLabel": "Refund amount (USD)*",
      "refundPolicyLegend": "Refund policy",
      "refundPolicyOptions": {
        "full": "full",
        "none": "none",
        "partial": "partial"
      },
      "selectAll": "Select all ({{count}})",
      "selectedCount": "{{selected}}/{{total}} selected",
      "submit": "Cancel order (permanent)",
      "subtitle": "Cancel the order with refund + vendor compensation. Refund > $500 or force-cancel order > $1000 → dual-approval.",
      "title": "Cancel order",
      "toastDualApprovalDesc": "threshold — waiting for a second approver (id {{id}}).",
      "toastDualApprovalTitle": "Moved to dual-approval",
      "toastError": "Failed to cancel order",
      "toastSuccess": "Order cancelled"
    },
    "common": {
      "cancel": "Cancel",
      "centsLine": "= {{cents}} cents",
      "clear": "Clear",
      "processing": "Processing…"
    },
    "reasonCodes": {
      "CHANGED_MIND": "Changed mind",
      "CUSTOMER_REQUEST": "Customer request",
      "DUPLICATE_ORDER": "Duplicate order",
      "FRAUD_SUSPECTED": "Fraud suspected",
      "OTHER": "Other",
      "POLICY_VIOLATION": "Policy violation",
      "SYSTEM_ERROR": "System error",
      "VENDOR_FAILURE": "Vendor failure",
      "WRONG_ADDRESS": "Wrong address",
      "WRONG_ARTWORK": "Wrong artwork",
      "WRONG_PRODUCT": "Wrong product"
    },
    "refund": {
      "amountLabel": "Refund amount (USD)*",
      "aria": "Refund order",
      "centsLine": "= {{cents}} cents · {{mode}}",
      "fullButton": "Full (${{amount}})",
      "modeFull": "full refund",
      "modePartial": "partial",
      "noteLabel": "Note",
      "reasonCodeLabel": "Reason code*",
      "submit": "Refund",
      "subtitle": "Create a refund. Refunds > $500 move to dual-approval.",
      "title": "Refund",
      "toastError": "Refund failed",
      "toastSuccess": "Refund request submitted"
    },
    "resend": {
      "aria": "Resend order",
      "costLabel": "Cost responsibility*",
      "costOptions": {
        "platform": "platform (0/100)",
        "shared": "shared (50/50)",
        "vendor": "vendor (100/0)"
      },
      "reasonLabel": "Reason (≥ 10 chars)*",
      "submit": "Resend",
      "subtitle": "Create a reprint order. Cost responsibility decides who pays.",
      "title": "Resend / Reissue",
      "toastError": "Resend failed",
      "toastSuccess": "Reprint order created",
      "vendorLabel": "Vendor (leave empty = keep original vendor)",
      "vendorPlaceholder": "(optional override)"
    },
    "surcharge": {
      "amountLabel": "Surcharge amount (USD)*",
      "aria": "Add surcharge",
      "paymentMethodLabel": "Payment method (optional)",
      "paymentOptions": {
        "credit": "credit",
        "default": "(use default)",
        "wallet": "wallet"
      },
      "reasonLabel": "Reason (≥ 10 chars)*",
      "submit": "Add surcharge",
      "subtitle": "Create a surcharge attached to the order. Reason must be at least 10 characters.",
      "title": "Add surcharge",
      "toastError": "Failed to add surcharge",
      "toastSuccess": "Surcharge added"
    }
  },
  "admin": {
    "sendOnBehalf": {
      "section": {
        "title": "Send to production (admin)",
        "description": "Approve and send this waiting order to production on behalf of the merchant."
      },
      "button": "Send to production (on behalf)",
      "submitting": "Sending…",
      "confirm": {
        "title": "Send to production on behalf?",
        "body": "This approves the order and hands it off to production on behalf of the merchant. The merchant will be notified. Continue?",
        "confirmLabel": "Send to production",
        "cancelLabel": "Cancel"
      },
      "success": "Order sent to production on behalf of the merchant.",
      "successDesc": "{{count}} item(s) assigned to production.",
      "error": "Could not send the order to production.",
      "errorInvalidState": "This order is no longer waiting for approval.",
      "errorNotFound": "Order not found.",
      "blocked": {
        "title": "Artwork not validated",
        "body": "One or more items are blocked because their artwork is not validated. Resolve them before sending to production.",
        "areasLabel": "Blocking areas:",
        "areaItem": "Area {{area}} — {{status}}"
      }
    }
  },
  "chips": {
    "aria": "Issues sub-filters",
    "clear": "Clear",
    "descriptions": {
      "dlq_failed": "Background worker hit dead-letter queue.",
      "mapping_error": "Vendor SKU / capability mapping missing or stale.",
      "quality_issue": "Production failed at vendor QA.",
      "shipping_problem": "Carrier reported exception / failed package."
    },
    "statusLabels": {
      "dlq_failed": "DLQ-Failed",
      "mapping_error": "Mapping Error",
      "quality_issue": "Quality Issue",
      "shipping_problem": "Shipping Problem"
    },
    "subFilter": "Sub-filter"
  },
  "csvImport": {
    "columns": {
      "error": "Error",
      "status": "Status"
    },
    "page": {
      "description": "Upload a CSV file to reassign the vendor for many orders at once. A 2-step process: preview → confirm apply (all-or-none).",
      "heading": "Import CSV to reassign vendor",
      "reasonHint": "minimum 20 characters.",
      "requiredColumnsLabel": "Required columns:"
    },
    "status": {
      "INVALID": "Error",
      "OK": "OK",
      "SKIP-cancelled": "Skipped (cancelled)",
      "SKIP-shipped": "Skipped (shipped)"
    },
    "step1": {
      "downloadTemplate": "Download CSV template",
      "heading": "Step 1 — Upload CSV file",
      "preview": "Preview",
      "previewing": "Previewing…",
      "selectedPrefix": "Selected:"
    },
    "step2": {
      "applyConfirm": "Confirm apply ({{count}})",
      "applying": "Applying…",
      "downloadErrors": "Download error report (.csv)",
      "heading": "Step 2 — Preview results",
      "invalidLabel": "Errors:",
      "moreRows": "Showing {{shown}} / {{total}} rows. Download the error report to see full details.",
      "skipLabel": "Skipped:",
      "totalLabel": "Total:",
      "validLabel": "Valid:"
    },
    "toast": {
      "applyFailTitle": "Apply failed",
      "applySuccessDesc": "Reassigned the vendor for {{count}} orders.",
      "applySuccessTitle": "Applied successfully",
      "emptyFileDesc": "Please choose a CSV file with at least 1 data row.",
      "emptyFileTitle": "Empty file",
      "invalidResponseDesc": "The server returned invalid preview data.",
      "invalidResponseTitle": "Invalid response",
      "networkErrorDesc": "Could not connect to the server",
      "networkErrorTitle": "Network error",
      "noFileDesc": "Please choose a CSV file before previewing.",
      "noFileTitle": "No file selected",
      "noValidRowsDesc": "Fix the errors then re-upload the CSV.",
      "noValidRowsTitle": "No valid rows",
      "previewReadyDesc": "{{valid}}/{{total}} rows valid. Expires in {{minutes}} minutes.",
      "previewReadyTitle": "Preview ready",
      "tooLargeDesc": "Maximum size is 5 MB. Current file is {{size}} MB.",
      "tooLargeTitle": "File too large",
      "unknownError": "Unknown error",
      "uploadFailTitle": "Upload failed",
      "wrongFormatDesc": "Please choose a .csv file",
      "wrongFormatTitle": "Wrong format"
    }
  },
  "detail": {
    "back": "Back to Orders",
    "badRoute": {
      "body": "Please return to the orders list.",
      "title": "Invalid order"
    },
    "loadError": "Unable to load order details.",
    "loading": "Loading order…",
    "tabs": {
      "finance": "Finance",
      "history": "History & Support",
      "overview": "Overview",
      "sectionsAria": "Order detail sections",
      "shipping": "Shipping"
    },
    "vendorOverride": {
      "button": "Edit vendor",
      "description": "Change the vendor for this order. Pure ownership transfer — does NOT trigger re-approval.",
      "title": "Override vendor (admin)"
    }
  },
  "header": {
    "grandTotalLabel": "Order total",
    "statusLabels": {
      "accepted": "Accepted",
      "assigned": "Assigned",
      "attention_required": "Attention Required",
      "cancelled": "Cancelled",
      "confirmed": "Confirmed",
      "delivered": "Delivered",
      "draft": "Draft",
      "in_production": "In Production",
      "on_hold": "On Hold",
      "partially_cancelled": "Partially Cancelled",
      "partially_shipped": "Partially Shipped",
      "pending_emb_payment": "Pending Emb. Payment",
      "pending_payment": "Pending Payment",
      "pending_reassignment": "Pending Reassign",
      "quality_check": "Quality Check",
      "ready_to_ship": "Ready to Ship",
      "returned_partial": "Returned (Partial)",
      "shipped": "Shipped",
      "unknown": "Unknown"
    },
    "copyBarcode": "Copy barcode",
    "actions": {
      "assign": "Assign",
      "reassign": "Reassign",
      "refund": "Refund",
      "resend": "Resend",
      "cancel": "Cancel order",
      "surcharge": "Add surcharge"
    }
  },
  "leftColumn": {
    "adminNotes": {
      "empty": "No notes yet.",
      "heading": "Internal notes",
      "loading": "Loading…",
      "placeholder": "Internal note — visible to admins only.",
      "save": "Save",
      "saveFailed": "Failed to save note",
      "readOnly": "You do not have permission to add internal notes — existing notes are read-only."
    },
    "compensationHistory": {
      "empty": "No compensation yet.",
      "heading": "Compensation history",
      "loading": "Loading…"
    },
    "deliveryAddress": {
      "adjustedBadge": "Adjusted",
      "diffTitle": "Customer input → Normalized",
      "heading": "Delivery address",
      "noAddress": "This order has no delivery address yet."
    },
    "items": {
      "artworkAlt": "Artwork {{num}}",
      "artworkCount": "{{count}} file",
      "artworkLabelFallback": "Artwork",
      "artworkNone": "None",
      "columns": {
        "artwork": "Artwork",
        "cogs": "COGS",
        "embroidery": "Embroidery",
        "price": "Price",
        "product": "Product",
        "quantity": "Qty",
        "shippingFee": "Shipping fee",
        "sku": "SKU",
        "status": "Status",
        "total": "Total",
        "unitPrice": "Unit Price",
        "vendor": "Vendor"
      },
      "download": "Download artwork",
      "empty": "This order has no items yet.",
      "expandHint": "Click a row to view artwork",
      "heading": "Items ({{count}})",
      "lineTotal": "Line total",
      "noArtworkUpload": "This item has no uploaded artwork.",
      "thumbnailNa": "N/A",
      "unknownProduct": "Unknown product",
      "vendorFallback": "Vendor #{{id}}",
      "vendorUnassigned": "Unassigned",
      "totals": {
        "subtotal": "Subtotal",
        "embroidery": "Embroidery",
        "shipping": "Shipping",
        "surcharge": "Surcharge",
        "tax": "Tax",
        "grandTotal": "Grand Total"
      }
    },
    "orderInfo": {
      "heading": "Order info",
      "labels": {
        "createdAt": "Created at",
        "orderId": "Order ID",
        "orderNumber": "Order number",
        "payment": "Payment",
        "status": "Status",
        "updatedAt": "Updated at"
      }
    },
    "refundHistory": {
      "backendPending": "Refunds are not available yet — they will appear once the refund system is deployed.",
      "empty": "No refund requests yet.",
      "heading": "Refund history",
      "loading": "Loading…",
      "statusLabels": {
        "approved": "Approved",
        "failed": "Failed",
        "pending": "Pending",
        "rejected": "Rejected",
        "settled": "Settled"
      }
    },
    "relatedTickets": {
      "empty": "No linked tickets — the support module is not deployed yet.",
      "heading": "Related tickets",
      "loading": "Loading…"
    },
    "shippingTracking": {
      "empty": "No shipment yet.",
      "errorHint": "Tracking info will be available once the vendor confirms the shipment.",
      "heading": "Shipping & Tracking",
      "loading": "Loading…"
    },
    "surchargeHistory": {
      "empty": "No surcharges.",
      "heading": "Surcharge history",
      "loading": "Loading…"
    },
    "timeline": {
      "empty": "No events yet.",
      "heading": "Timeline",
      "loading": "Loading…"
    }
  },
  "list": {
    "sub": {
      "unit": "Unit",
      "shipping": "Shipping",
      "total": "Total",
      "artworkOk": "Artwork",
      "artworkNone": "No artwork"
    },
    "actions": {
      "openOrderAria": "Open order {{orderNumber}}",
      "openOrderTitle": "Open order detail"
    },
    "bulk": {
      "approvalCount": "{{count}} pending approval",
      "approvalDesc": "Batch parked. Request id {{requestId}}; {{count}} orders > threshold {{threshold}}.",
      "approvalTitle": "Dual approval required",
      "exportQueuedDesc": "Export job {{jobId}} queued for {{count}} orders ({{format}}).",
      "exportQueuedTitle": "Export queued",
      "failedCount": "{{count}} failed",
      "failedTitle": "Bulk action failed",
      "noneAffected": "No orders affected.",
      "noneSelectedDesc": "Select at least one order to run this bulk action.",
      "noneSelectedTitle": "No orders selected",
      "okCount": "{{count}} applied",
      "queuedCount": "{{count}} queued",
      "reassignNoneSelectedDesc": "Select at least one order to bulk reassign vendor.",
      "skippedDesc": "{{count}} selected order(s) not eligible for this action (status) — skipped",
      "skippedTitle": "Some orders skipped",
      "submittedTitle": "Bulk action submitted",
      "ineligibleVendorChange": "None of the selected orders can change vendor — shipped, delivered, cancelled and returned orders are locked.",
      "ineligibleCancel": "None of the selected orders can be cancelled — shipped, delivered, cancelled and returned orders are locked.",
      "ineligibleResend": "Resend only applies to delivered or partially returned orders."
    },
    "bulkActions": {
      "assign": "Assign Vendor",
      "cancel": "Cancel",
      "export": "Export CSV",
      "reassign": "Bulk Reassign Vendor",
      "refund": "Refund",
      "resend": "Resend"
    },
    "columns": {
      "approved": "Approved",
      "items": "Items",
      "lastUpdated": "Last Updated",
      "orderId": "Order ID",
      "received": "Received",
      "source": "Source",
      "status": "Status",
      "store": "Store",
      "surcharge": "Surcharge",
      "total": "Total",
      "tracking": "Tracking",
      "vendor": "Vendor",
      "product": "Product",
      "platform": "Platform",
      "orderType": "Order Type",
      "merchantEmail": "Merchant email",
      "sla": "SLA",
      "resetColumns": "Reset columns",
      "saveFailedTitle": "Couldn't save column layout",
      "actions": "Actions"
    },
    "filters": {
      "search": {
        "label": "Search",
        "placeholder": "Order number, ID, tracking…"
      },
      "source": {
        "label": "Source"
      },
      "status": {
        "label": "Status"
      },
      "store": {
        "label": "Store",
        "placeholder": "All stores"
      },
      "payment": {
        "label": "Payment status",
        "placeholder": "All payment statuses"
      },
      "artwork": {
        "label": "Artwork status",
        "placeholder": "All artwork statuses"
      },
      "product": {
        "label": "Product",
        "placeholder": "Search product…"
      }
    },
    "unassigned": "Unassigned",
    "empty": "No orders match your filters.",
    "errors": {
      "network": "Network error — check connection"
    },
    "manualAssign": "Manual Assign",
    "page": {
      "heading": "Orders",
      "subtitle": "Cross-merchant order list. Multi-select bulk actions apply single-page only."
    },
    "prompts": {
      "cancelReason": "Cancellation reason:",
      "refundReason": "Refund reason:",
      "resendReason": "Resend reason:",
      "saveView": "Save current filter as view named:",
      "vendorId": "Vendor ID (24-hex):"
    },
    "reasonCategories": {
      "capacity_overflow": "Capacity overflow",
      "manual_reroute": "Manual reroute",
      "other": "Other",
      "quality_concern": "Quality concern",
      "vendor_downtime": "Vendor downtime"
    },
    "reassign": {
      "appliedDesc": "{{count}} orders reassigned to {{vendor}}.",
      "appliedTitle": "Bulk reassign applied",
      "applyFailedTitle": "Apply failed",
      "applying": "Applying…",
      "aria": "Bulk reassign vendor",
      "cancel": "Cancel",
      "categoryLabel": "Reason category*",
      "cols": {
        "current": "Current",
        "error": "Error",
        "orderId": "Order ID",
        "status": "Status"
      },
      "confirmApply": "Confirm Apply",
      "confirmApplyCount": "Confirm Apply ({{count}})",
      "description": "{{count}} orders selected. Pure ownership transfer — does not trigger re-approve. Reason at least {{min}} characters.",
      "newVendorFallback": "new vendor",
      "preview": "Preview",
      "previewBatchId": "batchId: {{batchId}}…",
      "previewFailedTitle": "Preview failed",
      "previewInvalidVendor": "{{count}} invalid vendor",
      "previewOther": "{{count}} other",
      "previewSkipStatus": "{{count}} skip status",
      "previewValid": "{{count}} valid",
      "previewing": "Previewing…",
      "reasonLabel": "Reason* ({{current}}/{{min}}+ chars)",
      "reasonPlaceholder": "Long-form justification (audit log)…",
      "title": "Bulk Reassign Vendor",
      "vendorLabel": "New vendor*",
      "vendorPlaceholder": "Pick vendor…",
      "hintNoVendor": "None of the selected orders have a vendor to reassign from. Use “Assign Vendor” to set a vendor first.",
      "hintNoValid": "No selected orders are eligible for reassignment."
    },
    "savedViews": {
      "appliedTitle": "Saved view applied",
      "applyPlaceholder": "— Apply saved view —",
      "archive": "Archive",
      "createdDesc": "\"{{name}}\" — restored from this filter.",
      "createdTitle": "Saved view created",
      "deleteFailedTitle": "Delete saved view failed",
      "deleteLatest": "Delete latest",
      "deleteLatestTitle": "Delete the most-recent saved view",
      "deletedTitle": "Saved view deleted",
      "label": "Saved view",
      "saveCurrent": "Save current",
      "saveFailedTitle": "Save view failed"
    },
    "archive": {
      "_comment": "Phase 3.3 Amendment #3 — Archive custom view (bucket=archive).",
      "badge": "Archive",
      "clear": "Exit archive view",
      "empty": "No archived orders."
    },
    "toolbar": {
      "importTitle": "Import CSV — bulk reassign vendor",
      "export": "Export",
      "exporting": "Exporting…",
      "searchPlaceholder": "Search by order#, email, product name, tracking...",
      "filterPending": "This filter will be wired once the BE supports it",
      "productPlaceholder": "Product",
      "refreshTitle": "Refresh / clear filters",
      "statusOptions": {
        "placeholder": "Status",
        "draft": "Draft",
        "waiting": "Waiting Approval",
        "assigned": "Assigned",
        "in_production": "In Production",
        "ready_to_ship": "Ready to Ship",
        "shipped": "Shipped",
        "delivered": "Delivered",
        "on_hold": "On Hold",
        "cancelled": "Cancelled"
      }
    },
    "sla": {
      "overdue": "Overdue",
      "dueInDays": "{{days}}d left",
      "dash": "—"
    },
    "assignModal": {
      "aria": "Assign vendor to selected orders",
      "title": "Assign Vendor",
      "description": "Assign a vendor to {{count}} selected order(s).",
      "vendorLabel": "Vendor",
      "vendorPlaceholder": "Pick vendor…",
      "cancel": "Cancel",
      "confirm": "Assign vendor"
    }
  },
  "modals": {
    "addSurcharge": {
      "amountCentsHint": "Equals {{cents}} cents.",
      "amountError": "Amount must be greater than 0 with at most 2 decimal places.",
      "amountLabel": "Amount (USD)",
      "amountPlaceholder": "e.g. 12.50",
      "autoPayNotice": "Merchant has auto-pay enabled — the surcharge will be charged to the wallet automatically.",
      "cancel": "Cancel",
      "descDefault": "Add a surcharge to this order.",
      "descWithLabel": "Add a surcharge to order {{label}}.",
      "enoughChars": "Looks good",
      "errors": {
        "network": "Connection error — please try again."
      },
      "needMoreChars": "{{count}} more characters needed",
      "paymentCredit": "Credit",
      "paymentMethodLegend": "Payment method",
      "paymentWallet": "Wallet",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "Enter a reason (at least {{min}} characters)…",
      "submit": "Add surcharge",
      "submitting": "Processing…",
      "title": "Add surcharge"
    },
    "assign": {
      "blacklist": "Blacklist",
      "cancel": "Cancel",
      "capacityShort": "Capacity {{pct}}%",
      "costGuard": {
        "break_even": "break-even",
        "loss": "loss",
        "profit": "profit"
      },
      "descAssign": "Pick a vendor to handle the order and add a reason for the audit log.",
      "descBulk": "The selected vendor will be applied to the entire selected list. Ineligible orders will land in the failed list.",
      "descReassign": "Current vendor: {{vendor}}. Pick a new vendor and add a reason.",
      "dualApprovalBanner": "Bulk > 5 orders — dual approval is required before applying.",
      "enoughChars": "Looks good",
      "errors": {
        "network": "Network error - check connection",
        "suggestionsLoad": "Could not load the vendor suggestions"
      },
      "needMoreChars": "{{count}} more characters needed",
      "overrideScoreLabel": "Override the 5-factor suggestion (override score)",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "At least {{min}} characters, for the audit log.",
      "scoreLabel": "Score {{score}}",
      "selectButton": "Select",
      "submitAssign": "Assign vendor",
      "submitBulk": "Assign to {{count}} orders",
      "submitReassign": "Switch vendor",
      "submitting": "Assigning…",
      "suggestionsEmpty": "No eligible vendors — enter a vendor manually below.",
      "suggestionsLoading": "Loading suggestions…",
      "suggestionsTitle": "Top 3 suggestions (5-factor formula)",
      "titleAssign": "Assign vendor to order (assign)",
      "titleBulk": "Assign vendor to {{count}} orders",
      "titleReassign": "Switch to another vendor (reassign)",
      "vendorIdError": "Vendor ID must be a 24-character hex string.",
      "vendorIdLabel": "Vendor ID",
      "vendorIdPlaceholder": "24-char ObjectId (pick from suggestions or paste directly)",
      "whitelist": "Whitelist"
    },
    "assignmentSimulation": {
      "adjustWeightsHint": "Adjust the weights so they sum to 1.00 before viewing results.",
      "allocationBranch": "This item routes by allocation share, so the pick ignores price and preference.",
      "applyButton": "Apply with selected vendor",
      "applyWord": "Apply",
      "cancel": "Cancel",
      "costDesc": "Production cost for this item, relative to the rest of the pool.",
      "costLabel": "Cost",
      "descLead": "What-if simulator for the vendor scoring panel. Results are",
      "descMid": "— they only affect the next",
      "descNot": "not saved",
      "descTail": "with the selected vendor.",
      "errors": {
        "network": "Connection error — please try again.",
        "sumRejected": "The server rejected these weights: the four axes must sum to exactly 1.00 (received {{sum}}).",
        "outOfRangeAxes": "Out of range: {{axes}}"
      },
      "noVendorInPool": "No vendor in the pool qualifies.",
      "notPersistedHint": "Simulation is not saved — it only affects the next Apply action.",
      "poolSize": "Vendors the pick would be made from: {{size}}",
      "preferenceApplied": "Preference ranking reordered the vendors tied at the top score.",
      "ratingDesc": "The vendor's quality rating.",
      "ratingLabel": "Rating",
      "recalculating": "Recalculating…",
      "resetButton": "Reset to the live weights",
      "ruleContext": {
        "allowNarrowed": "The merchant's allow-list removed vendors from this pool.",
        "blocked": "Blocked by the merchant's routing rules: {{value}}",
        "frozen": "Frozen by admin at this location: {{value}}",
        "fenced": "Outside the location fence: {{value}}",
        "hardFilter": "Rejected by the capability filter: {{value}}",
        "rejected": "Already tried for this item: {{value}}",
        "rulesReadFailed": "The merchant's routing rules could not be read, so the item was held rather than routed on a guess. This is a system fault, not a rule the merchant set."
      },
      "slaDesc": "On-time delivery performance against the promised window.",
      "slaLabel": "SLA",
      "sumWarningPrefix": "Weights must sum to 1.00. Currently:",
      "title": "Assignment simulation (what-if)",
      "tooltipAdjustFirst": "Adjust weights to 1.00 to run the simulation first",
      "tooltipSelectVendor": "Select a vendor in the list below to enable",
      "topVendorHeading": "Top vendors after re-scoring",
      "utilizationDesc": "How much of the vendor's daily capacity is still free.",
      "utilizationLabel": "Utilization",
      "weightsHeading": "Weights (sum = {{sum}})",
      "weightsLoading": "Reading the live weight set…",
      "weightsSource": {
        "live": "Live weights — what the router would use for this item right now.",
        "override": "Your override — preview only. The live weight set is unchanged and nothing here is saved."
      },
      "weightsVersion": "Weight set v{{version}}"
    },
    "refund": {
      "adminSuffix": " (admin)",
      "alreadyRefunded": "Already refunded",
      "ariaEstimatedRefund": "Estimated refund for {{label}}",
      "ariaRefundScope": "Refund scope",
      "backendPendingBody": "Refund could not be created — the Phase 4 module is not deployed in this environment, or the order is missing. The audit entry has been recorded locally.",
      "backendPendingTitle": "Backend pending",
      "bannerAwaitingMid": "is",
      "bannerAwaitingPost": "pending a second admin signoff.",
      "bannerAwaitingPre": "Refund",
      "bannerPendingDesc": "Refunds greater than $500 require a second admin signoff.",
      "cancel": "Cancel",
      "charsUnit": "chars",
      "close": "Close",
      "description": "Phase 4 owns the refund backend. This modal submits the request to the canonical service; funds are credited to the merchant wallet on completion.",
      "destinationPrefix": "Refund destination:",
      "destinationSuffix": ". No other destination is supported in this build.",
      "destinationWallet": "merchant wallet",
      "errors": {
        "noRefundable": "No refundable line items remain on this order.",
        "noteTooLong": "Reason note must be ≤ {{max}} characters.",
        "otherRequiresNote": "Reason \"Other\" requires a note explaining the refund.",
        "qtyExceeds": "Quantity for \"{{label}}\" exceeds remaining refundable ({{max}}).",
        "qtyInteger": "Quantity for \"{{label}}\" must be a non-negative integer.",
        "requestFailed": "Refund request failed — please retry.",
        "selectOne": "Select at least one line item with quantity > 0."
      },
      "estimatedTotal": "Estimated total",
      "gatewayDefault": "Stripe (default)",
      "lineItems": "Line items",
      "lineItemsFull": "(full quantities preselected)",
      "lineItemsPartial": "(set quantities to refund)",
      "maxQty": "(max {{max}})",
      "maxRefundable": "Max refundable",
      "originalGateway": "Original gateway",
      "queuedFor": "for",
      "queuedIs": "is",
      "queuedPre": "Refund",
      "queuedTitle": "Refund queued",
      "queuedTo": "to merchant wallet.",
      "reasonCodes": {
        "CHANGED_MIND": "Customer changed mind",
        "CUSTOMER_REQUEST": "Customer request (goodwill)",
        "DUPLICATE_ORDER": "Duplicate order",
        "FRAUD_SUSPECTED": "Fraud suspected",
        "OTHER": "Other (justify in note)",
        "POLICY_VIOLATION": "Policy violation",
        "SYSTEM_ERROR": "System error",
        "VENDOR_FAILURE": "Vendor failure",
        "WRONG_ADDRESS": "Wrong shipping address",
        "WRONG_ARTWORK": "Wrong artwork applied",
        "WRONG_PRODUCT": "Wrong product shipped"
      },
      "reasonLabel": "Reason",
      "reasonNoteLabel": "Reason note (optional, ≤ {{max}} chars)",
      "reasonNotePlaceholder": "Explain the refund context for the audit log…",
      "serverComputed": "(server-computed final)",
      "submitRefund": "Refund {{amount}}",
      "submitRequest": "Request refund ({{amount}})",
      "submitting": "Submitting…",
      "tabFull": "Full refund",
      "tabPartial": "Partial refund",
      "title": "Refund order — {{order}}",
      "toastAwaitingDesc": "Refund > $500 requires a second admin signoff.",
      "toastAwaitingTitle": "Awaiting peer approval",
      "toastBackendDesc": "Refund could not be processed — Phase 4 service not yet deployed or order missing.",
      "toastBackendTitle": "Backend pending",
      "toastFailedTitle": "Refund failed",
      "toastProcessingDesc": "{{order}} — {{amount}} queued to merchant wallet.",
      "toastProcessingTitle": "Refund processing"
    },
    "resend": {
      "close": "Close",
      "costLabels": {
        "platform": "Platform pays in full (0% vendor / 100% platform)",
        "shared": "Split 50/50 (50% vendor / 50% platform)",
        "vendor": "Vendor pays in full (100% vendor / 0% platform)"
      },
      "costLegend": "Cost responsibility (who pays)",
      "costNotice": "The merchant wallet is not charged (resend does not charge the merchant) — cost is split between vendor and platform.",
      "descDefault": "Create a new order linked to the original. The merchant is not charged — cost is split per cost-responsibility.",
      "descWithNumberPost": ". The merchant is not charged (resend does not deduct the merchant wallet — cost is split per cost-responsibility).",
      "descWithNumberPre": "Create a new order linked to the original",
      "enoughChars": "Looks good",
      "errors": {
        "network": "Network error - check connection"
      },
      "itemsLegend": "Items to reprint",
      "itemsRequired": "Select at least 1 item",
      "needMoreChars": "{{count}} more characters needed",
      "newVendorError": "Vendor id must be a 24-char hex ObjectId",
      "newVendorPlaceholder": "e.g. 64f0c1a2b3c4d5e6f7a8b9c0",
      "noVendor": "Order has no vendor yet",
      "previewLabel": "Destination vendor preview:",
      "previewNewEmpty": "(no new vendor entered)",
      "previewNoVendor": "— (order has no vendor)",
      "previewSameId": "{{id}}… (keep the existing vendor)",
      "previewSameNamed": "{{name}} (keep the existing vendor)",
      "reasonLabel": "Resend reason",
      "reasonPlaceholder": "Enter a reason (at least {{min}} characters)…",
      "submit": "Create resend order",
      "submitting": "Creating new order…",
      "targetLegend": "Resend target (destination vendor)",
      "targetNew": "Switch to a new vendor",
      "targetNewHint": "Enter a vendor id (24-char hex ObjectId)",
      "targetSame": "Same vendor (keep)",
      "title": "Resend order (reprint)"
    }
  },
  "pendingAssign": {
    "actions": {
      "assign": "Manual assign",
      "assignFailDefault": "Manual assignment failed.",
      "cancel": "Cancel",
      "escalate": "Report escalation",
      "escalateFail": "{{fail}} orders could not be escalated.",
      "partialResult": "Assigned {{success}}/{{total}} orders. {{fail}} failed — see details below.",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "Record the reason for the manual assignment for the audit log",
      "requiredFields": "Please enter the Vendor ID, vendor name, and a reason for the manual assignment.",
      "resultSuccess": "success",
      "resultUnknownError": "unknown error",
      "selectedPrefix": "Selected",
      "selectedSuffix": "orders",
      "skip": "Skip",
      "submit": "Submit",
      "submitting": "Processing…",
      "vendorIdLabel": "Vendor ID",
      "vendorIdPlaceholder": "ObjectId 24-hex",
      "vendorNameLabel": "Vendor name",
      "vendorNamePlaceholder": "e.g. PrintCo VN",
      "escalateReason": "Admin requested early escalation (manual override)"
    },
    "page": {
      "autoRefresh": "Auto-refreshes every 30 seconds.",
      "columns": {
        "escalated": "Escalated",
        "items": "Items",
        "orderId": "Order ID",
        "received": "Received",
        "slaRemaining": "SLA remaining",
        "status": "Status",
        "tier": "Alert level"
      },
      "description": "Queue of orders that could not be auto-assigned to a vendor. SLA 2 hours — overdue orders are automatically escalated to the Super Admin.",
      "empty": "No orders are awaiting manual assignment.",
      "escalatedYes": "Yes",
      "heading": "Pending Manual Assign",
      "loadError": "Could not load the Pending Manual Assign queue.",
      "loading": "Loading queue…",
      "selectAll": "Select all",
      "selectRow": "Select order {{orderId}}",
      "tiers": {
        "T1": "Warning (1h-2h)",
        "T2": "Overdue (2h-4h)",
        "T3": "Urgent (>4h)",
        "none": "Within SLA"
      }
    }
  },
  "refundPanel": {
    "awaitingApproval": "Awaiting dual-approval signoff.",
    "backendPending": "Refunds will appear here after Phase 4 module deploys.",
    "defaultTitle": "Refund history",
    "empty": "No refunds have been issued for this order yet.",
    "errorFallback": "Failed to load refund history.",
    "loading": "Loading refunds…",
    "refreshing": "Refreshing…",
    "statusLabels": {
      "approved": "Approved",
      "failed": "Failed",
      "pending": "Pending",
      "processed": "Processed",
      "rejected": "Rejected"
    }
  },
  "rightColumn": {
    "financialSummary": {
      "cogs": "COGS",
      "costGatedBadge": "cost-gated",
      "margin": "Margin",
      "naValue": "N/A",
      "payoutsPending": "Payouts pending",
      "perItemRow": "{{item}} · vendor {{vendor}}",
      "perItemSummary": "Vendor cost per item ({{count}})",
      "revenue": "Revenue",
      "title": "Financial summary"
    },
    "merchantInfo": {
      "customer": "Customer",
      "email": "Email",
      "phone": "Phone",
      "title": "Merchant"
    },
    "paymentInfo": {
      "grandTotal": "Grand total",
      "placeholderHint": "The transaction link will appear once Phase 8.2 is deployed.",
      "title": "Payment",
      "viewTransaction": "View transaction →"
    },
    "statusActions": {
      "actions": {
        "assign": "Assign / Reassign",
        "cancel": "Cancel order",
        "refund": "Refund",
        "resend": "Resend",
        "surcharge": "Add surcharge"
      },
      "statusLabels": {
        "accepted": "Accepted",
        "assigned": "Assigned",
        "cancelled": "Cancelled",
        "confirmed": "Confirmed",
        "delivered": "Delivered",
        "draft": "Draft",
        "in_production": "In production",
        "on_hold": "On hold",
        "pending_emb_payment": "Pending EMB payment",
        "pending_payment": "Pending payment",
        "pending_reassignment": "Pending reassignment",
        "returned": "Returned",
        "shipped": "Shipped"
      },
      "title": "Status"
    },
    "vendorScore": {
      "alternatives": "Alternatives (top {{count}})",
      "assignedBadge": "Assigned",
      "contributionNote": "The value to the right of the = sign is the weighted contribution. The sum of contributions = total score.",
      "costAxisLabel": "Normalised cost axis (0–1) and the vendor's production cost for this order.",
      "costNotDeclared": "No cost declared",
      "errorNetwork": "Network error - check connection",
      "factors": {
        "cost": "Cost",
        "rating": "Rating",
        "sla": "SLA",
        "utilization": "Utilization"
      },
      "formulaBodyV3": " — score = rating × {{rating}} + utilization × {{utilization}} + SLA × {{sla}} + cost × {{cost}}.",
      "formulaLink": "{{version}} (§6.13 Order Assign Rules)",
      "formulaPrefix": "Formula",
      "heading": "Vendor scoring breakdown",
      "legacyBadge": "Legacy",
      "legacyExplain": "This assignment was scored before the cost axis existed, so no cost was recorded for it.",
      "loading": "Loading breakdown…",
      "noScored": "No vendor has been scored for this order yet.",
      "rerunButton": "Re-run scoring (Test weights — not saved)",
      "retry": "Retry",
      "totalLabel": "Total",
      "weightsProvenance": "Weights in force when this order was assigned — not today's set.",
      "weightsVersion": "Weight set v{{version}}",
      "weightsVersionUnknown": "Weight set: none recorded",
      "weightsVersionFallback": "shipped defaults — no approved set was readable",
      "multiItemNotice": "This explains one item of {{count}} on the order. Each item is routed separately against its own vendor pool, so scores from different items are not comparable.",
      "unknownVendor": "Vendor no longer exists"
    },
    "vendors": {
      "empty": "No vendor assigned yet.",
      "itemCount_one": "{{count}} item",
      "itemCount_other": "{{count}} items",
      "title": "Vendors",
      "vendorFallback": "Vendor #{{id}}"
    },
    "production": {
      "stateLabels": {
        "in_production": "In production",
        "quality_check": "Quality check",
        "ready_to_ship": "Ready to ship"
      },
      "vendorUnassigned": "No vendor assigned",
      "empty": "No item is in production yet."
    },
    "salesPerson": {
      "unassigned": "Not assigned",
      "attributionPending": "Attribution — pending backend (Task 53 / D-494)."
    },
    "vendorPushAlerts": {
      "stuckPre": "Order stuck in",
      "stuckPost": "for {{days}} days (threshold {{threshold}} days).",
      "rejectPre": "Vendor push to",
      "rejectPost": "was rejected",
      "missingFields": "— missing: {{fields}}"
    }
  },
  "settings": {
    "policyStub": "SLA & order policy — coming soon.",
    "tabs": {
      "bulk": "Bulk Tools",
      "policy": "Policy"
    }
  },
  "paymentStatusLabels": {
    "paid": "Paid",
    "partial": "Partial",
    "pending": "Pending",
    "refunded": "Refunded",
    "unpaid": "Unpaid"
  },
  "sourceLabels": {
    "api": "API",
    "etsy_import": "Etsy",
    "manual_admin": "Admin created",
    "merchant_dashboard": "Merchant created",
    "other": "Other",
    "partner_api": "Partner API",
    "shopify_import": "Shopify",
    "tiktok_import": "TikTok"
  },
  "statusLabels": {
    "accepted": "Accepted",
    "assigned": "Assigned",
    "attention_required": "Attention Required",
    "cancelled": "Cancelled",
    "confirmed": "Confirmed",
    "delivered": "Delivered",
    "draft": "Draft",
    "in_production": "In Production",
    "on_hold": "On Hold",
    "partially_cancelled": "Partially Cancelled",
    "partially_shipped": "Partially Shipped",
    "pending_emb_payment": "Pending Emb. Payment",
    "pending_payment": "Pending Payment",
    "pending_reassignment": "Pending Reassign",
    "quality_check": "Quality Check",
    "ready_to_ship": "Ready to Ship",
    "returned_partial": "Returned (Partial)",
    "shipped": "Shipped",
    "unknown": "Unknown"
  },
  "tabs": {
    "aria": "Order tabs",
    "descriptions": {
      "all": "All cross-merchant orders.",
      "cancelled": "Cancelled or partially cancelled (transitional).",
      "delivered": "Delivered to customer.",
      "draft_unpaid": "Drafts and pending-payment orders.",
      "issues": "On-hold / reassignment / returned-partial — chip row sub-filters.",
      "pending": "Confirmed / assigned / accepted by vendor.",
      "pending_manual_assign": "auto-dispatcher fell back; admin must manually pick a vendor.",
      "processing": "In production / quality check / ready to ship.",
      "resent": "Items resent (transitional).",
      "shipped": "Shipped (whole or partial).",
      "unassigned": "Confirmed orders waiting for vendor assignment."
    },
    "labels": {
      "all": "All",
      "cancelled": "Cancelled",
      "delivered": "Delivered",
      "draft_unpaid": "Draft-Unpaid",
      "issues": "Issues",
      "pending": "Pending",
      "pending_manual_assign": "Pending Manual Assign",
      "processing": "Processing",
      "resent": "Resent",
      "shipped": "Shipped",
      "unassigned": "Unassigned"
    }
  },
  "timeline": {
    "aria": "Order status",
    "cancelledBanner": "Order cancelled / returned — the processing lifecycle no longer applies.",
    "statusLabels": {
      "approval": "Approval",
      "delivered": "Delivered",
      "new": "New",
      "production": "In Production",
      "shipped": "Shipped",
      "assigned": "Assigned",
      "accepted": "Accepted",
      "quality_check": "Quality Check",
      "ready_to_ship": "Ready to Ship"
    },
    "issuePrefix": "Needs attention — ",
    "issueLabels": {
      "error-artwork": "Artwork error",
      "unverified": "Address unverified",
      "on_hold": "On hold",
      "attention_required": "Attention required",
      "pending_reassignment": "Pending reassignment",
      "unknown": "Unknown state"
    }
  },
  "vendorOverride": {
    "cancel": "Cancel",
    "categoryLabel": "Reason category*",
    "hint": "Override the vendor for this order. Reason ≥ {{min}} characters + pick a category. NO re-approve.",
    "reasonCategories": {
      "capacity_overflow": "Capacity overflow",
      "manual_reroute": "Manual reroute",
      "other": "Other",
      "quality_concern": "Quality concern",
      "vendor_downtime": "Vendor downtime"
    },
    "reasonCounter": "{{current}} / {{min}} minimum characters",
    "reasonLabel": "Reason (≥ {{min}} characters)*",
    "submit": "Override vendor",
    "submitting": "Overriding…",
    "title": "Edit vendor (single override)",
    "toast": {
      "errorDefault": "Vendor override failed",
      "errorInvalidCategory": "Invalid reason category",
      "errorNoVendor": "Order has no vendor — use Assign vendor instead of Override",
      "errorNoop": "New vendor is the same as the current vendor",
      "errorReasonTooShort": "Reason must be at least {{min}} characters",
      "errorStatusLocked": "Order has moved to shipping",
      "successDesc": "The new vendor has been assigned to the order (NO re-approve).",
      "successTitle": "Vendor overridden"
    },
    "vendorLabel": "New vendor*",
    "vendorPlaceholder": "Pick vendor…"
  },
  "common": {
    "close": "Close"
  },
  "orderType": {
    "BASIC": "Basic",
    "SAMPLE": "Sample",
    "BULK_FBA_FBT": "Bulk (FBA/FBT)",
    "BUNDLE": "Bundle"
  },
  "artworkLabels": {
    "ok": "OK",
    "missing": "Missing"
  },
  "promoBanner": {
    "title": "Buy more, save more with bulk discounts!",
    "subtitle": "Order 10+ items and get up to 15% off on shipping & products.",
    "itemsOrdered": "Items ordered",
    "itemsOrderedValue": "10+ items",
    "shippingDiscount": "Shipping discount",
    "shippingDiscountValue": "Up to 10%",
    "productDiscount": "Product discount",
    "productDiscountValue": "Up to 5%",
    "learnMore": "Learn More",
    "goToSettings": "Go to settings",
    "settings": {
      "routing": "Routing:",
      "disabled": "Disabled",
      "approval": "Approval:",
      "automatic": "Automatic",
      "trackingNotifications": "Tracking notifications:",
      "delayedOrders": "Delayed orders:",
      "manual": "Manual"
    }
  },
  "inlineVendor": {
    "assign": "Assign",
    "reassign": "Reassign",
    "assignedFallback": "Assigned",
    "unpaidTooltip": "Vendor can be assigned only after the item is paid",
    "toast": {
      "successTitle": "Vendor updated",
      "errorDefault": "Could not update the vendor",
      "errorUnpaid": "This item is unpaid — payment is required first",
      "errorConflict": "The item changed in another tab — reload and retry",
      "errorNoop": "That is already the current vendor",
      "errorLocked": "Vendor cannot be changed at this order stage",
      "errorNoVendor": "This item has no vendor yet — assign one first"
    },
    "dialog": {
      "assignTitle": "Assign vendor to item",
      "reassignTitle": "Reassign item vendor",
      "vendorPlaceholder": "Search vendor…",
      "reasonCategoryLabel": "Reason category",
      "reasonLabel": "Reason (min {min} characters)",
      "reasonPlaceholder": "Why is this vendor being set?",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "saving": "Saving…"
    },
    "reasonCategories": {
      "capacity_overflow": "Capacity overflow",
      "vendor_downtime": "Vendor downtime",
      "manual_reroute": "Manual reroute",
      "quality_concern": "Quality concern",
      "other": "Other"
    }
  },
  "_vgBinding": "vg-binding: P8.1.1.D-15 — i18n keys for new order-list columns (product/platform/orderType/merchantEmail/sla), SLA cell labels, order-type + artwork enum LABELS (values stay English), and store/payment/artwork/product filter labels across en/vi/fr [task-11]",
  "capabilityReasons": {
    "canRefund": {
      "preAssign": "Order not paid yet — no transaction to refund",
      "terminal": "Order is in a terminal state — cannot refund"
    },
    "canCancel": {
      "terminal": "Order is in a terminal state",
      "shipped": "Order handed to the carrier — cannot cancel"
    },
    "canResend": "Resend is only available once the order is delivered or returned (return-to-sender)",
    "canReassign": "The order has shipped or reached a terminal state — the vendor can no longer be changed",
    "canEscalate": "Order is in a terminal state — no escalation needed",
    "canReassignPreAssign": "The order is not paid yet — a vendor cannot be assigned"
  },
  "reasons": {
    "BLOCKED_BY_MERCHANT_RULE": "The merchant's own routing rules left no eligible vendor, so the item is waiting for a manual assignment.",
    "MERCHANT_RULES_UNAVAILABLE": "The merchant's routing rules could not be read, so the item was held rather than routed on a guess. This is a system fault, not a rule the merchant set — check the service before editing any rules.",
    "NO_VENDOR_FOR_LOCATION": "No vendor is bound to this location for this variant, so the item is waiting for a manual assignment.",
    "NO_VENDOR_MATCH": "No vendor matched this item, so it is waiting for a manual assignment.",
    "VENDOR_LOCATION_FROZEN": "Every vendor for this location is frozen by an admin, so the item is waiting for a manual assignment. Unfreeze one on the vendor's Locations tab, or assign by hand."
  }
}
